import { Country } from '../../lib/types/models/country/country'
import { CountryInput } from '../../lib/types/models/country/country-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createCountry(data: CountryInput) {
  return restApiClient
    .url(constructApiUrl(API.countries.create.url, null))
    .post<Country, CountryInput>(data)
}
